import { useAtom } from "jotai";
import {
  EndDateAtom,
  ExpensesAtom,
  GoalAtom,
  IncomeAtom,
  PredefinedGoalsAtom,
  ProjectNameAtom,
  StartDateAtom
} from "./atoms";
import { opt } from "./utils";
import * as D from "date-fns";
import { Step } from "./step";
import * as React from "react";
import { formatMoney } from "./formatters";
import * as strings from "./strings";

const {
  topbar_expenses_label,
  topbar_goal_label,
  topbar_income_label,
  topbar_period_label,
  topbar_projectname_label
} = strings;

export function App() {
  const [startDate] = useAtom(StartDateAtom);
  const [endDate] = useAtom(EndDateAtom);
  const [projectName] = useAtom(ProjectNameAtom);
  const [income] = useAtom(IncomeAtom);
  const [expenses] = useAtom(ExpensesAtom);
  const [goal] = useAtom(GoalAtom);

  useAtom(PredefinedGoalsAtom); // use atom to make sure jotai knows it is being used
  return (
    <>
      <div className="atc-topbar">
        <div className="atc-topbar__inner page_container">
          <div className="atc-topbar__container">
            <p className="atc-topbar__text atc-topbar__text--nowrap">
              <span>{topbar_projectname_label}</span> {projectName}
            </p>
          </div>
          <div className="atc-topbar__container">
            <p className="atc-topbar__text">
              <span>{topbar_goal_label}</span> {formatMoney(goal)}
            </p>
            <p className="atc-topbar__text">
              <span>{topbar_period_label}</span>{" "}
              {opt(startDate, startDate => D.format(startDate, "yyyy"))} -{" "}
              {opt(endDate, endDate => D.format(endDate, "yyyy"))}
            </p>
            <p className="atc-topbar__text">
              <span>{topbar_income_label}</span> {formatMoney(income)}
            </p>
            <p className="atc-topbar__text">
              <span>{topbar_expenses_label}</span> {formatMoney(expenses)}
            </p>
          </div>
        </div>
      </div>
      <div className="analysis-tool">
        <div className="analysis-tool__image-container object-fit">
          <img
            src={window["mttFinancialAnalysisToolAssets"]?.imageBanner}
            alt="cover image"
          />
        </div>

        <div className="analysis-tool__content-container page_container">
          <Step />
        </div>
      </div>
    </>
  );
}
